import React, { ComponentProps, useContext } from 'react';

import CloseButton from '@adsk/alloy-react-close-button';
import { useTheme } from '@adsk/alloy-react-styles';

import ModalContext from '../ModalContext';

type Props = ComponentProps<typeof CloseButton>;

const Close = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      style,
      className,
      onClick,
      showEscapeLabel: showEscapeLabelProp,
      ...props
    },
    ref,
  ) => {
    const theme = useTheme();
    const modalTokens = theme.tokens?.component?.modal;
    const context = useContext(ModalContext);

    const showEscapeLabel =
      showEscapeLabelProp !== undefined
        ? showEscapeLabelProp
        : context?.shouldCloseOnEsc;

    return (
      <CloseButton
        {...props}
        ref={ref}
        className={className}
        showEscapeLabel={showEscapeLabel}
        style={[
          {
            marginTop: modalTokens?.['close-button']?.['margin-top'],
            padding: 0,
          },
          style,
        ]}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick && onClick(e);
        }}
      />
    );
  },
);

Close.displayName = 'Close';

Close.propTypes = {
  ...CloseButton.propTypes,
};

export default Close;
